module.exports = __webpack_public_path__ + "static/img/20.79121b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/20.png
// module id = XGIY
// module chunks = 1